export function calculateLength(chromatogram, seriesName) {
    const series2D = chromatogram.getSeries2D(seriesName);
    const spectra = series2D.getData();
    return spectra.map((spectrum) => spectrum[0].length);
}
//# sourceMappingURL=calculate_length.js.map